import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const scrollToElement = (id, options = { behavior: "auto", block: "start" }) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView(options);
  }
};

export const useScrollToHash = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      scrollToElement(location.hash.substring(1));
    }
  }, [location]);
};